// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"397":"37c3cd17d2914339","524":"54e29d0115b203d7","715":"670301ea45b06a9d","764":"dd1dbb30c9349058","775":"d22971326b92aabc","859":"179038656a637576","878":"097765ad144cb7f6"}[chunkId] + ".js";
};